const parkRoutes = {
  index: {
    path: 'index.maneuver.park',
    url: '/garage',
  },
}

export default parkRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/park/routes.js